function tryDecreaseDepth(dragItem) {
  var _this$props = this.props,
      childrenProp = _this$props.childrenProp,
      collapsed = _this$props.collapsed;
  var pathFrom = this.getPathById(dragItem.id);
  var itemIndex = pathFrom[pathFrom.length - 1]; // has parent

  if (pathFrom.length > 1) {
    var parent = this.getItemByPath(pathFrom.slice(0, -1)); // is last (by order) item in array

    if (itemIndex + 1 === parent[childrenProp].length) {
      var pathTo = pathFrom.slice(0, -1);
      pathTo[pathTo.length - 1] += 1; // if collapsed by default and is last (by count) item in array remove this node from list of open nodes

      var collapseProps = {};

      if (collapsed && parent[childrenProp].length === 1) {
        collapseProps = this.onToggleCollapse(parent, true);
      }

      this.moveItem({
        dragItem: dragItem,
        pathFrom: pathFrom,
        pathTo: pathTo
      }, collapseProps);
    }
  }
}

export { tryDecreaseDepth };
//# sourceMappingURL=tryDecreaseDepth.js.map
